import React from 'react'
import './Tree.css'

function Tree() {
    return (
        <div className="tree">
            <div className="lineCenter"></div>
            <div className="treeBlock">
                <div><p>Amet labore cillum dolore minim minim anim laborum consectetur aliqua et elit Lorem. Qui enim magna incididunt excepteur. Aliquip pariatur aute enim excepteur deserunt velit sunt sunt ea amet non proident id voluptate. Occaecat ullamco laborum nisi voluptate id deserunt aliquip nostrud velit eiusmod ea laboris qui sit. </p></div>
                <div>01</div>
                <div>
                    <h4>Graphic Designer</h4>
                    <p>Team Orio Designer Team</p>
                    <p>March 2019-August 2019</p>
                </div>
            </div>
            <div className="treeBlock">
                <div><p>Amet labore cillum dolore minim minim anim laborum consectetur aliqua et elit Lorem. Qui enim magna incididunt excepteur. Aliquip pariatur aute enim excepteur deserunt velit sunt sunt ea amet non proident id voluptate. Occaecat ullamco laborum nisi voluptate id deserunt aliquip nostrud velit eiusmod ea laboris qui sit. </p></div>
                <div>02</div>
                <div>
                    <h4>UI/UX Designer</h4>
                    <p>Deveexper Designer Team</p>
                    <p>March 2019-August 2019</p>
                </div>
            </div>
            <div className="treeBlock">
                <div><p>Amet labore cillum dolore minim minim anim laborum consectetur aliqua et elit Lorem. Qui enim magna incididunt excepteur. Aliquip pariatur aute enim excepteur deserunt velit sunt sunt ea amet non proident id voluptate. Occaecat ullamco laborum nisi voluptate id deserunt aliquip nostrud velit eiusmod ea laboris qui sit. </p></div>
                <div>03</div>
                <div>
                    <h4>Web Developer</h4>
                    <p>DIVI Elegent Team</p>
                    <p>March 2019-August 2019</p>
                </div>
            </div>
        </div>
    )
}

export default Tree
